import React, { useRef, useState, useEffect } from "react";
import { authServer } from "../api/axios";
import "./Login.css";
import SAMLogo from "../icons/SAM-integrity-logo.svg";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";
import { Input, Checkbox } from "@progress/kendo-react-inputs";
import { Card } from "@progress/kendo-react-layout";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import jwt_decode from "jwt-decode";
import { setAuthChange } from "../redux/toolSelectSlice";
const Logout = () => {
    const dispatch = useDispatch();
    const mapConfig = useSelector((state) => state.configData.mapConfig);
    const [SiteName, setSiteName] = useState("");
    const navigate = useNavigate();
    const locaton = useLocation();
    const from = locaton.state?.from?.path || "/";
    const [authChangeDone, setAuthChangeDone] = useState(false);

    useEffect(() => {
        var now = new Date();
        document.cookie = `rft=""; sameSite=strict ; expires=${now.toUTCString()}`;
        document.cookie = `ast=""; sameSite=strict; expires=${now.toUTCString()}`;
    }, []);

    useEffect(() => {
        if (!mapConfig) {
            setSiteName("Loading");
        } else {
            setSiteName(`${mapConfig.DisplayName}`);
        }
    }, [mapConfig]);
    const handleSubmit = async (e) => {
        setAuthChangeDone(true);
        setTimeout(() => {
            navigate(from, { replace: true });
        }, 500);
    };
    useEffect(() => {
        if (authChangeDone) {
            dispatch(setAuthChange(true));
        }
    }, [authChangeDone]);

    return (
        <>
            <div className="content login">
                <img className="brand" src={SAMLogo} alt="SAM Logo"></img>
                <Card>
                    <header>
                        <img src={process.env.REACT_APP_SAM_LOGO_URL} alt="SAM Logo" />
                        <h1>Logged out</h1>
                    </header>
                    <p>The Sign Out operation was successful</p>

                    <Button onClick={handleSubmit}>Return To Site</Button>

                    <div>&nbsp;</div>
                </Card>
            </div>
        </>
    );
};
export default Logout;
